import { render } from "./icon-chevron.vue?vue&type=template&id=5cff0b62"
import script from "./icon-chevron.vue?vue&type=script&lang=js"
export * from "./icon-chevron.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__